// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"701c0990","239":"dfdb0d71","455":"455c5641"}[chunkId] + ".chunk.js";
};